<template>
    <DashboadCard>
        <div class="ranking">
            <div class="ranking__header">
                <DashboardIcon icon="store" color="#556EE6" />
                <div class="ranking__header-texts">
                    <div class="ranking__title">Top Tiendas con más Envíos</div>
                    <div class="ranking__subtitle">Tiendas con más envíos en el período</div>
                </div>
            </div>
            <div class="ranking__list">
                <div v-for="(store, index) in stores" :key="index" class="ranking__item">
                    <div class="ranking__position">{{ store.position }}</div>
                    <div class="ranking__avatar" :style="{ backgroundColor: store.avatarColor }">
                        {{ store.initials }}
                    </div>
                    <div class="ranking__info">
                        <div class="ranking__name">{{ store.name }}</div>
                    </div>
                    <div class="ranking__count">{{ store.deliveries }}</div>
                </div>
                <div v-if="stores.length === 0" class="ranking__empty">
                    Sin datos en el período
                </div>
            </div>
            <div v-if="totalPages > 1" class="ranking__pagination">
                <button class="ranking__page-btn" :disabled="currentPage <= 1" @click="changePage(currentPage - 1)">
                    <i class="material-icons">chevron_left</i>
                </button>
                <span class="ranking__page-info">{{ currentPage }} / {{ totalPages }}</span>
                <button class="ranking__page-btn" :disabled="currentPage >= totalPages"
                    @click="changePage(currentPage + 1)">
                    <i class="material-icons">chevron_right</i>
                </button>
            </div>
        </div>
    </DashboadCard>
</template>

<script>
import DashboadCard from './DashboadCard.vue';
import DashboardIcon from './DashboardIcon.vue';
import { mapGetters, mapActions } from 'vuex';

const AVATAR_COLORS = ['#556EE6', '#34C38F', '#F1B44C', '#F46A6A', '#50A5F1', '#74788D', '#343A40'];

export default {
    name: 'TopStoresRanking',
    components: {
        DashboadCard,
        DashboardIcon
    },
    computed: {
        ...mapGetters(['topStoresByDeliveries', 'dashboardFilters']),
        currentPage() {
            return this.topStoresByDeliveries?.page || 1;
        },
        totalPages() {
            return this.topStoresByDeliveries?.totalPages || 1;
        },
        stores() {
            return (this.topStoresByDeliveries?.stores || []).map((store, index) => ({
                position: store.position,
                initials: this.getInitials(store.name),
                name: store.name,
                deliveries: store.deliveries,
                avatarColor: AVATAR_COLORS[index % AVATAR_COLORS.length]
            }));
        }
    },
    methods: {
        ...mapActions(['fetchTopStoresByDeliveries']),
        getInitials(name) {
            if (!name) return '??';
            const words = name.trim().split(/\s+/);
            if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
            return (words[0][0] + words[1][0]).toUpperCase();
        },
        changePage(page) {
            this.fetchTopStoresByDeliveries({
                page,
                ...this.dashboardFilters
            });
        }
    }
}
</script>

<style scoped>
.ranking {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.ranking__header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
}

.ranking__header-texts {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
}

.ranking__title {
    font-size: 0.95rem;
    font-weight: 600;
}

.ranking__subtitle {
    font-size: 0.8rem;
    opacity: 0.6;
}

.ranking__list {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.ranking__item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 0;
    border-bottom: 1px solid #f0f0f0;
}

.ranking__item:last-child {
    border-bottom: none;
}

.ranking__position {
    font-size: 0.8rem;
    font-weight: 700;
    color: #999;
    width: 16px;
    text-align: center;
}

.ranking__avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.7rem;
    font-weight: 600;
    color: #fff;
    flex-shrink: 0;
}

.ranking__info {
    flex: 1;
    min-width: 0;
}

.ranking__name {
    font-size: 0.85rem;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ranking__count {
    font-size: 1.1rem;
    font-weight: 700;
    color: #333;
}

.ranking__empty {
    font-size: 0.85rem;
    opacity: 0.5;
    text-align: center;
    padding: 2rem 0;
}

.ranking__pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    margin-top: 0.75rem;
    padding-top: 0.5rem;
    border-top: 1px solid #f0f0f0;
}

.ranking__page-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: 1px solid #dce2e8;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    color: #333;
    transition: all 0.15s ease;
}

.ranking__page-btn:hover:not(:disabled) {
    background: #f5f5f5;
    border-color: #ccc;
}

.ranking__page-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.ranking__page-btn i {
    font-size: 18px;
}

.ranking__page-info {
    font-size: 0.8rem;
    color: #666;
    font-weight: 500;
}
</style>
